// extracted by mini-css-extract-plugin
module.exports = {"slideArticle":"_1wmFc","slider_bg":"_3-_mT","slider_hover":"j7I_1","slider_content":"_1_NS1"};